/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Tab_Plan_DraftInputs */

const en_us2_shell_tab_plan_draft = /** @type {(inputs: Shell_Tab_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan: a new plan is waiting`)
};

const pt_br2_shell_tab_plan_draft = /** @type {(inputs: Shell_Tab_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano: um novo plano está esperando`)
};

const es_419_shell_tab_plan_draft = /** @type {(inputs: Shell_Tab_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan: hay un nuevo plan esperando`)
};

const pt_pt2_shell_tab_plan_draft = /** @type {(inputs: Shell_Tab_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano: há um novo plano à espera`)
};

const fr_fr2_shell_tab_plan_draft = /** @type {(inputs: Shell_Tab_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme : un nouveau programme t'attend`)
};

const de_de2_shell_tab_plan_draft = /** @type {(inputs: Shell_Tab_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan: ein neuer Plan wartet`)
};

const it_it2_shell_tab_plan_draft = /** @type {(inputs: Shell_Tab_Plan_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda: una nuova scheda ti aspetta`)
};

/**
* | output |
* | --- |
* | "Plan: a new plan is waiting" |
*
* @param {Shell_Tab_Plan_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_tab_plan_draft = /** @type {((inputs?: Shell_Tab_Plan_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Tab_Plan_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_tab_plan_draft(inputs)
	if (locale === "es-419") return es_419_shell_tab_plan_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_tab_plan_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_tab_plan_draft(inputs)
	if (locale === "de-DE") return de_de2_shell_tab_plan_draft(inputs)
	if (locale === "it-IT") return it_it2_shell_tab_plan_draft(inputs)
	return en_us2_shell_tab_plan_draft(inputs)
});
export { shell_tab_plan_draft as "shell.tab_plan_draft" }